/**
 * @file transfer-groups.ts
 * @description Список «Передать диалог» (chat-window-design.md §4):
 * блок «Ведёт заказ» сверху, затем «Остальные» (сервер уже отсортировал по
 * роли и имени); поиск по имени — когда сотрудников больше 7.
 */

import type { TransferCandidate } from "../../lib/api-chat";

export const TRANSFER_SEARCH_FROM = 8;

export interface TransferGroups {
  leadsOrder: TransferCandidate[];
  others: TransferCandidate[];
}

export function transferGroups(list: readonly TransferCandidate[], query: string): TransferGroups {
  const q = query.trim().toLocaleLowerCase("ru-RU");
  const found = q ? list.filter((c) => c.name.toLocaleLowerCase("ru-RU").includes(q)) : list;
  return {
    leadsOrder: found.filter((c) => c.leadsOrder),
    others: found.filter((c) => !c.leadsOrder),
  };
}
